import { IRevenueSpendPageLang } from '../../../types/lang'

export const revenueSpendPageLang: IRevenueSpendPageLang = {
	revenue_spend_page: {
		btn_add_new: 'Add New_ru',
	}
}